import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { PlaybackEventEmitter, PlaybackEvent, useUserUUID } from '@annunciate/core';
import { usePlaying } from '../../hooks/player';
export const usePlayingDownloadDeletedListener = () => {
    const isPlaybackFromDownload = useRef(false);
    const uuid = useUserUUID();
    const { playing } = usePlaying();
    const client = useQueryClient();
    useEffect(() => {
        async function run() {
            if (playing?.id) {
                let download = await client.getQueryData([`downloads:${uuid}`, { id: playing.id }]);
                if (download) {
                    isPlaybackFromDownload.current = true;
                }
                else {
                    isPlaybackFromDownload.current = false;
                }
            }
        }
        run();
        const listener = async (item) => {
            const currentId = playing?.id || '';
            const deletedId = item.id;
            if (currentId.toString() === deletedId.toString() &&
                isPlaybackFromDownload.current === true) {
                PlaybackEventEmitter.emit(PlaybackEvent.STOP);
            }
        };
        PlaybackEventEmitter.on(PlaybackEvent.CONTENT_DELETED, listener);
        return () => {
            PlaybackEventEmitter.off(PlaybackEvent.CONTENT_DELETED, listener);
        };
    }, [
        playing?.id,
        uuid,
    ]);
};
//# sourceMappingURL=usePlayingDownloadDeletedListener.js.map